import logoIcon from './LogoIcon.png';

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return <img src={logoIcon} alt="AccuSmart" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />;
}
